import * as PlansActionCreators from 'actions/plans';
import * as StoryletActionTypes from 'actiontypes/storylet';
import PlansService from 'services/PlansService';
import { ICreatePlanRequestData } from 'types/plans';

const service = new PlansService();

/** ----------------------------------------------------------------------------
 * CREATE PLAN
 -----------------------------------------------------------------------------*/
export default function createPlan(branchData: ICreatePlanRequestData) {
  return async (dispatch: Function) => {
    dispatch(createPlanRequest());
    try {
      await service.createPlan(branchData);
      dispatch(createPlanSuccess(branchData.id));
      return await dispatch(PlansActionCreators.fetchPlans());
    } catch (error) {
      console.error(error);
      dispatch(createPlanFailure(error));
    }
  };
}

const createPlanRequest = () => ({
  type: StoryletActionTypes.CREATE_PLAN_REQUESTED,
  isFetching: true,
});

const createPlanSuccess = (branchId: number) => ({
  type: StoryletActionTypes.CREATE_PLAN_SUCCESS,
  isFetching: false,
  setActiveId: branchId,
  payload: { branchId },
});

const createPlanFailure = (error: any) => ({
  type: StoryletActionTypes.CREATE_PLAN_FAILURE,
  isFetching: false,
  error: true,
  status: error.response && error.response.status,
});